import React from "react";
import { ModalSuccess } from "~misc/icons";

const RotaDoDiaRotasConcluidas = () => {
  return (
    <div className="mt-12" data-testid="rotas-concluidas-container" aria-label="Mensagem de conclusão das rotas">
      <ModalSuccess />
      <h2 className="xl:text-4xl md:text-3xl sm:text-3xl font-bold text-center max-w-[600px] mx-auto">
        Você visitou todos os clientes planejados para hoje!
      </h2>
    </div>
  );
};

export default RotaDoDiaRotasConcluidas;
